import styled from 'styled-components';

export const Flex = styled.div`
	display: flex;
	align-items: center;
	flex-basis: 33%;
	padding: 5% 5% 3%;
	justify-content: space-between;

	& > div,
	& > ul {
		flex: 2;
	}

	@media (max-width: ${({ theme }) => theme.tab}) {
		align-items: flex-start;
		padding-top: 40px 20%;
		margin: 10% 5%;
		justify-content: space-between;
	}

	@media (max-width: ${({ theme }) => theme.mobile}) {
		flex-direction: column;
		align-items: center;
		padding-top: 40px;
		margin: 10% 5%;
	}
`;
